import { Select } from "ant-design-vue";
import "ant-design-vue/dist/antd.less";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { fmtMsg, ActionItem } from "commonui";
import { LessonPlanLocale } from "@/locales/localeid";
import { ILessonPlanTemplateModel } from "@/models/lesson-plan";
import LabelText from "@/components/label-text/label-text.vue";
@Component({
	components: {
		"a-select": Select,
		"a-select-option": Select.Option,
		LabelText,
		ActionItem
	}
})
export default class LessonPlanTemplateDownload extends Vue {
	@Prop() templates!: ILessonPlanTemplateModel[];
	@Prop() lessonPlanIsValid!: boolean;
	@Prop() onDownloadTemplate!: (template: ILessonPlanTemplateModel) => void;
	selectedTemplate: ILessonPlanTemplateModel | undefined;

	get lessonPlanLocale(): any {
		return LessonPlanLocale;
	}

	canDownload(): boolean {
		return this.lessonPlanIsValid && this.selectedTemplate != undefined;
	}

	onTemplateSelected(selectedValue: string): void {
		this.selectedTemplate = this.templates.find(template => template.id == selectedValue);
		this.$forceUpdate();
		this.$emit("change", this.selectedTemplate);
	}

	onDownloadTemplateFile(): void {
		this.onDownloadTemplate && this.canDownload() && this.selectedTemplate && this.onDownloadTemplate(this.selectedTemplate);
	}
}
